var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"article-action-link",attrs:{"type":"button"},on:{"click":_vm.compartir_por_whatsapp}},[_c('i',{staticClass:"bi bi-share",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v("Compartir")])])}
var staticRenderFns = []

export { render, staticRenderFns }